export const GOOGLE_ANALYTICS_CONSENT_KEY = "google-analytics";
